import ajax from 'axios'

/**
 * Default way to accept a response with valid status within 200-299 range
 * @param response
 * @returns {boolean}
 */
function acceptableStatuses(response) {
  return response.status >= 200 && response.status < 300
}

/**
 * Get ajax call to endpoint URL
 *
 * @param url
 * @param validateResponse function(response) to check, defaulted to acceptableStatuses
 * @returns { success, data, errorMsg }: { boolean, object, string }
 */
export async function get(url, validateResponse = acceptableStatuses) {
  try {
    const response = await ajax.get(url)
    if (response && validateResponse(response)) {
      return { success: true, data: await response.data }
    }
    return {
      success: false,
      data: await response.data,
      errorMsg: (response && (await response.statusText)) || 'Service Error',
    }
  } catch (err) {
    return {
      success: false,
      data: {},
      errorMsg: err && err.response && err.response.statusText,
    }
  }
}

/**
 * Post ajax call to endpoint URL with body
 *
 * @param url
 * @param body
 * @param validateResponse function(response) to check, defaulted to acceptableStatuses
 * @returns { success, data, errorMsg }: { boolean, object, string }
 */
export async function post(url, body, validateResponse = acceptableStatuses) {
  let options = {
    method: 'POST',
    url,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: body,
  }
  try {
    const response = await ajax(options)

    if (response && validateResponse(response)) {
      return { success: true, data: await response.data }
    }
    return {
      success: false,
      data: await response.data,
      errorMsg: (response && (await response.statusText)) || 'Service Error',
    }
  } catch (err) {
    return { success: false, data: {}, errorMsg: err.response.statusText }
  }
}
